module.exports = __webpack_public_path__ + "static/img/M-5.e53b75d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myixuekao/M-5.png
// module id = qkiP
// module chunks = 0